import { type MouseEvent, forwardRef } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const InformationsIcon = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      d="M8.26299 6.77956C8.53401 6.77956 8.75569 6.99547 8.76282 7.26639L8.88712 11.9868C8.89453 12.268 8.66859 12.5 8.3873 12.5H7.56752C7.28451 12.5 7.05792 12.2653 7.06782 11.9825L7.23311 7.26206C7.24253 6.99289 7.46347 6.77956 7.7328 6.77956H8.26299Z"
      fill="currentColor"
      stroke="none"
    />
    <path
      d="M9 5C9 5.55228 8.55229 6 8 6C7.44772 6 7 5.55228 7 5C7 4.44772 7.44772 4 8 4C8.55229 4 9 4.44772 9 5Z"
      fill="currentColor"
      stroke="none"
    />
    <circle cx="8" cy="8" r="7" stroke="currentColor" strokeWidth="1.5" />
  </svg>
));
